function genOption(text: string) {
  return { label: text, value: text };
}

export const TEXT_OTHER = () => {
  const { $t } = useNuxtApp();
  return $t('qi-ta');
};
export const usedForOption = () => {
  const { $t } = useNuxtApp();
  return [
    genOption($t('ge-ren-shi-pin-chuang-zuo')),
    genOption($t('qi-ye-yong-tu')),
    genOption($t('bang-gong-si-qi-ta-ren-kan-kan-xin-de-shi-pin-sheng-chan-gong-ju')),
    genOption($t('zhi-shi-hao-qi-xiang-yao-le-jie-xia-aigc-fang-mian-de-gong-ju')),
    genOption(TEXT_OTHER()),
  ];
};

export const contactDurationOption = () => {
  const { $t } = useNuxtApp();
  return [
    genOption($t('1-nian-nei')),
    genOption($t('12-nian')),
    genOption($t('23-nian')),
    genOption($t('3-nian-ji-yi-shang')),
  ];
};

export const createDurationOption = () => {
  const { $t } = useNuxtApp();
  return [
    genOption($t('30s-yi-nei')),
    genOption($t('30s-1min')),
    genOption($t('1min-3min')),
    genOption($t('3min-yi-shang')),
  ];
};

export const createFrequencyOption = () => {
  const { $t } = useNuxtApp();
  return [
    genOption($t('mei-zhou-chuang-zuo-zhi-shao-yi-tiao')),
    genOption($t('mei-yue-chuang-zuo-zhi-shao-yi-tiao')),
    genOption($t('ou-er-chuang-zuo')),
  ];
};

export const workIndustryOption = () => {
  const { $t } = useNuxtApp();
  return [
    genOption($t('jin-rong')),
    genOption($t('pei-xun')),
    genOption($t('mei-zhuang-kuai-su-jiu-shui')),
    genOption($t('3c-jia-dian')),
    genOption($t('jiao-yu-k12')),
    genOption($t('zheng-wu')),
    genOption($t('guang-dian-mei-ti')),
    genOption('b2b'),
    genOption($t('fa-lv')),
    genOption($t('wen-lv')),
    genOption($t('qi-che')),
    genOption($t('yi-liao')),
    genOption($t('fan-hu-lian-wang')),
    genOption(TEXT_OTHER()),
  ];
};

export const scenariosOptions = () => {
  const { $t } = useNuxtApp();
  return [
    genOption($t('pin-pai-ying-xiao')),
    genOption($t('chan-pin-ying-xiao')),
    genOption($t('she-mei-yun-ying')),
    genOption($t('da-xing-huo-dong')),
    genOption($t('dian-shang-yun-ying')),
    genOption($t('ben-di-sheng-huo')),
    genOption($t('zhuan-ti-lan-mu')),
    genOption($t('qi-ye-nei-xun')),
    genOption($t('k12-jiao-yu')),
    genOption($t('lu-ping-jiang-jie')),
    genOption($t('dang-jian-jiao-yu')),
    genOption($t('zhi-shi-fen-xiang')),
    genOption($t('ge-ren-yong-tu')),
    genOption(TEXT_OTHER()),
  ];
};
